import Dashboard from '@/api/dashboard'

export const state = {
  branches: []
}

export const getters = {}

export const mutations = {
  SET_BRANCH(state, data) {
    state.branches = data
  }
}

export const actions = {
  fetchTotal(context = {}) {
    return Dashboard.getTotal().then(response => {
      return Promise.resolve(response)
    })
  },
  fetchCashCollectionByCashier(context, attrubutes = {}) {
    return Dashboard.getCashCollectionByCashier({
      params: {
        branch_id: attrubutes.branch_id,
        date_from: attrubutes.date_from,
        date_to: attrubutes.date_to
      }
    }).then(response => {
      return Promise.resolve(response.data)
    })
  },
  fetchTop10FastProductSold(context, attrubutes = {}) {
    return Dashboard.getTop10FastProductSold({
      params: {
        branch_id: attrubutes.branch_id,
        date_from: attrubutes.date_from,
        date_to: attrubutes.date_to
      }
    }).then(response => {
      return Promise.resolve(response.data)
    })
  },
  fetchSaleByProductGroup(context, attrubutes = {}) {
    return Dashboard.getSaleByProductGroup({
      params: {
        branch_id: attrubutes.branch_id,
        pro_group_id: attrubutes.pro_group_id,
        sale_date_by: attrubutes.sale_date_by,
        date_from: attrubutes.date_from,
        date_to: attrubutes.date_to
      }
    }).then(response => {
      return Promise.resolve(response.data)
    })
  },
  fetchSalePerformanceByHour(context, attrubutes = {}) {
    return Dashboard.getSalePerformanceByHour({
      params: {
        branch_id: attrubutes.branch_id,
        sale_date_by: attrubutes.sale_date_by,
        date_from: attrubutes.date_from,
        date_to: attrubutes.date_to
      }
    }).then(response => {
      return Promise.resolve(response.data)
    })
  },
  fetchPromotionStatistic(context, attrubutes = {}) {
    return Dashboard.getPromotionStatistic({
      params: {
        branch_id: attrubutes.branch_id,
        sale_date_by: attrubutes.sale_date,
        date_from: attrubutes.date_from,
        date_to: attrubutes.date_to
      }
    }).then(response => {
      return Promise.resolve(response.data)
    })
  },
  fetchTop10SlowProductSold(context, attrubutes = {}) {
    return Dashboard.getTop10SlowProductSold({
      params: {
        branch_id: attrubutes.branch_id,
        sale_date_by: attrubutes.sale_date,
        date_from: attrubutes.date_from,
        date_to: attrubutes.date_to
      }
    }).then(response => {
      return Promise.resolve(response.data)
    })
  },
  fetchQuotationStatistic(context, attrubutes = {}) {
    return Dashboard.getQuotationStatistic(attrubutes).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchSaleContractStatistic(context, attrubutes = {}) {
    return Dashboard.getSaleContractStatistic(attrubutes).then(response => {
      return Promise.resolve(response)
    })
  },
  fetchCustomerInvoiceStatistic(context, attrubutes = {}) {
    return Dashboard.getCustomerInvoiceStatistic(attrubutes).then(response => {
      return Promise.resolve(response.data)
    })
  },
  fetchVendorInvoiceStatistic(context, attrubutes = {}) {
    return Dashboard.getVendorInvoiceStatistic(attrubutes).then(response => {
      return Promise.resolve(response.data)
    })
  },
  fetchNearlyExpired(context, attrubutes = {}) {
    return Dashboard.getNearlyExpired(attrubutes).then(response => {
      return Promise.resolve(response.data)
    })
  },
  fetchReOrderProduct(context, attrubutes = {}) {
    return Dashboard.getReOrderProduct(attrubutes).then(response => {
      return Promise.resolve(response.data)
    })
  },
  fetchBalanceInventoryByBranch(context, attrubutes = {}) {
    return Dashboard.getBalanceInventoryByBranch({
      params: {
        filter: {
          pro_group_id: attrubutes.pro_group_id,
        }
      }
    }).then(response => {
      return Promise.resolve(response.data)
    })
  },
  fetchWareHouses(context, attrubutes = {}) {
    return Dashboard.getWareHouses(attrubutes).then(response => {
      return Promise.resolve(response.data)
    })
  },
  async getBranch(context) {
    if (!context.state.branches.length > 0) {
      let response = await Dashboard.getBranch()
      context.commit('SET_BRANCH', response.data)
      return response
    }
  },
  async getProductGroup(context, attrubutes = {}) {
    return Dashboard.getProductGroup(attrubutes).then(response => {
      return Promise.resolve(response.data)
    })
  }
}
